import React from 'react'
// import Loanbtn from './Loanbtn'
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
// import CoPresentIcon from '@mui/icons-material/CoPresent';
import { Link } from 'react-router-dom';

export default function HomeServices() {
    return (
        <div className='serviceWrap '>
            <div className='container pt-4 pb-4'>
                <div className='row p-3'>
                    <div className='col-lg-4 pt-4 pb-4'>
                        <div className='tag text-white '>Our Services</div>
                        <h3 className='text-white p-2'> Your Partner in Financial Growth</h3>
                        <p className='text-white pb-3 mt-3' style={{ lineHeight: '30px' }}>We empower salaried individuals by providing them with an Instant Personal Loan of up to ₹ 1,20,000 in just 10 minutes. This helps them navigate any financial challenge with ease, allowing them to move ahead with confidence.</p>
                        <Link to='/apply-now' className='btn-paynow'>Apply Now</Link>
                    </div>
                    <div className='col-lg-8 pt-4 pb-4'>
                        <div className='col-lg-12'>
                            <div className='border rounded-3 p-3'>
                                <div className='d-flex justify-content-between'>
                                    <h4 className='text-white'>SnapRupee  Loan</h4>
                                    <Link to='/emergency-loan'>
                                        <div className='arrow-box rounded-2'><ArrowOutwardIcon /></div>
                                    </Link>
                                </div>
                                <p className='text-white pt-2'>Specifically designed for critical circumstances, such as a sudden health emergency, an urgent credit card settlement, etc.</p>
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-lg-6 pt-3 '>
                                <div className='rounded-3 p-4 border'>
                                    <div className='d-flex justify-content-between'>
                                        <h4 className='text-white'>Instant Loan</h4>
                                        <Link to='/instant-personal-loan'>
                                            <div className='arrow-box rounded-2'><ArrowOutwardIcon /></div>
                                        </Link>
                                    </div>
                                    <p className='text-white pt-2 mb-0'>Specifically designed to obtain instant funds at lightning speed so that you can cover unexpected expenses without any hassle. </p>
                                </div>
                            </div>
                            <div className='col-lg-6 pt-3'>
                                <div className='rounded-3 p-4 border'>
                                    <div className='d-flex justify-content-between'>
                                        <h4 className='text-white'>Short-term Loan</h4>
                                        <Link to='/short-term-loan'>
                                            <div className='arrow-box rounded-2'><ArrowOutwardIcon /></div>
                                        </Link>
                                    </div>
                                    <p className='text-white pt-2 mb-0'>A small-ticket loan for Utility bill payments, unplanned travel, sudden purchases, festive/wedding shopping, and plenty more. </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
